import { useIsMobile } from '@/hooks/utilities/use-mobile';
import SlidingModal from '../home/mobile/SlidingModal';
import CustomDialog from '../ui/customDialog';
export default function DialogOrModal({
  hideClose = true,
  dialogClassName,
  modalClassName,
  isOpen,
  onClose,
  heightFit = true,
  children,
  dialogTrigger
}: {
  isOpen: boolean;
  onClose: () => void;
  dialogClassName?: string;
  modalClassName?: string;
  dialogTrigger?: () => React.ReactNode;
  children: React.ReactNode;

  //mobile only
  heightFit?: boolean;

  //desktop only
  hideClose?: boolean;
}) {
  const isMobile = useIsMobile();
  return <>
      {isMobile ? <SlidingModal className={modalClassName} isOpen={isOpen} onClose={onClose} heightFit={heightFit}>
          {children}
        </SlidingModal> : <>
          <CustomDialog className={dialogClassName} hideClose={hideClose} isOpen={isOpen} toggleModal={onClose} trigger={dialogTrigger ? dialogTrigger() : null}>
            {children}
          </CustomDialog>
        </>}
    </>;
}